<label [for]="name" appFormControl class="checkbox checkbox--{{ size() }}">
  <input
    (blur)="onBlur()"
    (change)="onChange()"
    (focus)="onFocus()"
    [attr.required]="required"
    [checked]="value"
    [disabled]="disabled"
    [id]="name"
    [name]="name"
    class="checkbox__input"
    type="checkbox"
  />
  <div [attr.aria-hidden]="true" class="checkbox__decorator">
    <svg class="checkbox__svg" height="9px" viewBox="0 0 12 9" width="12px">
      <polyline points="1 5 4 8 11 1" />
    </svg>
  </div>
  <span [innerHTML]="label()" class="checkbox__text"></span>
</label>
